import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import api from '../lib/api'
import useNotify from '../hooks/useNotify'

export const ALERT_TYPES = [
    { value: "#28a745", label: "Success" },
    { value: "#17a2b8", label: "Info" },
    { value: "#ffc107", label: "Warning" },
    { value: "#dc3545", label: "Problem" },
];

const AddNewAlert = ({ show, setShow, formData, action, setFormData, setNotification, onSaved }) => {
    const [loader, setLoader] = useState(false);
    const notify = useNotify(setNotification);

    const isAdd = action === "add";
    const close = () => setShow(false);

    const submit = (e) => {
        e.preventDefault();
        setLoader(true);

        const request = isAdd
            ? api.post('/alerts', formData)
            : api.put(`/alerts/${formData.id}`, formData);

        request
            .then((res) => {
                notify.success(res.data.message.en);
                close();
                if (onSaved) onSaved();
            })
            .catch((err) => notify.error(err))
            .finally(() => setLoader(false));
    };

    return (
        <Modal show={show} onHide={close} size='lg' centered>
            <Modal.Header closeButton><h2 className="modal-title-text">{isAdd ? "Add New Alert" : "Edit Alert"}</h2></Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <form className='row' onSubmit={submit}>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                {/* Inputs previously reused ids and names from the
                                    accounts form ("form-buyer", name="password"),
                                    which broke label targeting and autofill. */}
                                <label htmlFor="alert-title">Title*</label>
                                <input id="alert-title" required placeholder="Enter alert title" type="text" className="form-control" name="title" value={formData.title ?? ""} onChange={(e) => setFormData((prev) => ({ ...prev, title: e.target.value }))} />
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="alert-type">Alert type*</label>
                                <select id="alert-type" required className="form-control" name="alert_type" value={formData.alert_type ?? ""} onChange={(e) => setFormData((prev) => ({ ...prev, alert_type: e.target.value }))}>
                                    <option value="">Select Alert Type</option>
                                    {ALERT_TYPES.map((type) => <option key={type.value} value={type.value}>{type.label}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-12 mb-4">
                            <div className="form-group">
                                <label htmlFor="alert-message">Message*</label>
                                <textarea style={{ height: "100px" }} id="alert-message" required placeholder="Enter message" className="form-control" name="html" value={formData.html ?? ""} onChange={(e) => setFormData((prev) => ({ ...prev, html: e.target.value }))} />
                            </div>
                        </div>
                        <div className="modal-action-buttons">
                            <button type="submit" disabled={loader} className="submit-modal-form-btn">{loader ? <div className="button-loader"></div> : (isAdd ? "Submit" : "Save")}</button>
                            <button type="button" onClick={close} className="cancel-modal-form-btn">Cancel</button>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddNewAlert
